import tweeter from "./assets/tweeter.svg";
import omnistudy from "./assets/omnistudy.svg";
import stride from "./assets/stride.svg";
import joco from "./assets/joco.svg";
import skrape from "./assets/skrape.svg";
import neighbors from "./assets/neighbors.svg";
import smock from "./assets/smock.svg";
import smock2 from "./assets/smock2.svg";
import oMock from "./assets/oMock.svg";
import oMock2 from "./assets/oMock2.svg";
import tMock from "./assets/tMock.svg";
import skMock from "./assets/skMock.svg";
import skMock2 from "./assets/skMock2.svg";

export const projects = [
  {
    name: "Stride",
    description: "Stride is an all-encompassing fitness application.",
    fullDescription:
      "Stride is an all-encompassing fitness application that empowers users to share, discuss, and educate themselves on various aspects of fitness. The platform offers a seamless experience for users to log in or sign up, allowing them to create posts, comment on content, express appreciation through likes, and follow other users.",
    responsibilies:
      "I developed the entire fullstack app using React, Node.js, Express, and MongoDB. I also designed the UI/UX of the app using TailwindCSS and AWS S3 for image storage.",
    category: ["Full Stack", "Frontend", "Backend", "UI/UX"],
    techStack: [
      "React",
      "Node.js",
      "Express",
      "NoSQL",
      "MongoDB",
      "AWS S3",
      "TailwindCSS",
    ],
    logo: stride,
    images: [smock, smock2],
    path: "/stride",
    links: [
      {
        name: "Live App",
        url: "https://stride-app-a0afeefab00a.herokuapp.com/",
      },
    ],
  },
  {
    name: "Omnistudy",
    description:
      "AI educational app to help students achieve their academic goals.",
    fullDescription:
      "OmniStudy, meaning 'Study for all' with the Latin prefix 'omni' and the suffix 'study,' is a university-based artificial intelligence educational platform. It enables students to organize their work efficiently into foundational tasks such as courses, assignments, and lectures. Using AI, the platform allows students to upload personal documents for interaction through question answering, summarization, and question generation, helping them save time on coursework while gaining a solid understanding of the material. OmniStudy participated in the Google Developer Student Clubs 2024 Solution Challenge, targeting the United Nations goals for Quality Education and Reduced Inequalities, and placed in the top 100 submissions globally.",
    responsibilies:
      "My main responsibilities for OmniStudy: include leading the frontend development of the app, writing the majority of the frontend code, connecting the app to the backend, and serving as the UI/UX designer.",
    category: ["Full Stack", "Frontend", "UI/UX"],
    techStack: [
      "React",
      "TypeScript",
      "Node.js",
      "Express",
      "MySQL",
      "Python",
      "Docker",
      "AWS",
      "GCP",
      "TailwindCSS",
    ],
    logo: omnistudy,
    images: [oMock, oMock2],
    path: "/omistudy",
    links: [
      {
        name: "Demo Video",
        url: "https://www.youtube.com/watch?v=IHGnI6pRZzA",
      },
    ],
  },
  {
    name: "Tweeter",
    description:
      "A real-time messaging app where users engage in conversations sparked by randomly generated questions.",
    fullDescription:
      "Tweeter is a real time messaging app that allows users to engage in conversations with each other based on the random question that gets generated. By incorporating real-time messaging functionality, users can have seamless conversations with each other, fostering a sense of community and collaboration.",
    responsibilies:
      "My main responsibilities for Tweeter: include setting up all of the JWT authentication, connecting, styling, and creating the frontend using React, and setting up all of the mutations, resolvers, and typeDefs for our GraphQL express server.",
    category: ["Full Stack", "Frontend", "Backend", "UI/UX"],
    techStack: [
      "React",
      "Node.js",
      "Express",
      "MongoDb",
      "Mongoose",
      "GraphQL",
      "JWT",
      "Socket.io",
      "JavaScript",
      "TailwindCSS",
    ],
    logo: tweeter,
    images: [tMock],
    path: "/tweeter",
    links: [
      {
        name: "Github",
        url: "https://github.com/owenkanzler/tweeter",
      },
      {
        name: "Live App",
        url: "https://tweeter-4z96.onrender.com/",
      },
    ],
  },
  {
    name: "Skrape",
    description:
      "A web AI web scraper that allows users to extract data from websites.",
    fullDescription:
      "Skrape is a simple web scraper that uses the BeautifulSoup library and OpenAI Api to scrape the contents of a webpage and be able to summaraize and inform the user of the contents of the webpage.",
    category: ["Full Stack", "Frontend", "Backend", "UI/UX"],
    techStack: [
      "React",
      "Python3",
      "Flask",
      "BeautifulSoup",
      "OpenAI",
      "JavaScript",
      "TailwindCSS",
    ],
    logo: skrape,
    images: [skMock, skMock2],
    path: "/skrape",
    links: [
      {
        name: "Github",
        url: "https://github.com/owenkanzler/Skrape",
      },
    ],
  },
  {
    name: "JOCO",
    description: "Website made for a house detailing company.",
    category: ["Web Development", "UI/UX"],
    logo: joco,
    path: "https://joco-detailing.com/",
  },
  {
    name: "Neighbors Landscaping",
    description: "Website made for a landscaping company.",
    logo: neighbors,
    category: ["Web Development", "UI/UX"],
    path: "https://neighborsmn.com/",
  },
];
